import { mapGetters } from "vuex";
import utils from "../../utils/util";
import pageheader from "../pageheader";
import telematicsService from "../../api/telematics.service";
import moment from "moment";
import XLSX from "xlsx";
import rules from "../../utils/rules";
import config from "../../../secrets/config";

// Status labels used in the exported spreadsheet header. Order matters: the original
// code ran four sequential (not chained) if-checks with loose ==, so the LAST match
// wins — the loop below preserves that exactly.
const statusExportLabels = [
  [1, "Open"],
  [2, "Reservation"],
  [3, "Closed"],
  [5, "Overdue"],
];

export default {
  name: "equipments",
  components: { pageheader },
  data() {
    return {
      input: {},
      equipmentsList: [],
      isEquipmentsLoading: false,
      search: "",
      companyName: "",
      customerList: [],
      accessCodesList: [],
      selectedCustomer: null,
      isLoaderCustomer: false,
      searchCustomer: null,
      configdata: config.ENABLE_ACCESS_CODE,
      itemid: "",
      statusList: [
        {
          statusId: 1,
          statusName: "Open",
        },
        {
          statusId: 2,
          statusName: "Reservation",
        },
        {
          statusId: 3,
          statusName: "Closed",
        },
        {
          statusId: 5,
          statusName: "Overdue",
        },
      ],
      searchHeader: "",
      menu1: false,
      menu2: false,
      fromDate: "",
      toDate: "",
      status: 1,
      headers: [
        { text: "Map", value: "map" },
        { text: "Access Codes", value: "accesscodesview" },

        { text: "Equipment #", value: "stockKey" },
        { text: "Equipment", value: "name" },
        { text: "Telematics SN", value: "tuSerialNumber" },
        { text: "Customer Name", value: "customerName" },
        { text: "Contract#", value: "contractId" },
        { text: "Item Status", value: "itemStatus" },
        { text: "Quantity", value: "quantity" },

        { text: "Device Model", value: "deviceModel" },
        { text: "Start Date", value: "initialContractDate" },
        { text: "Estimated Return Date", value: "contractEndDate" },
        { text: "PO#", value: "customerPurchaseOrder" },
        { text: "Job#", value: "customerJobNumber" },
        { text: "Ordered By", value: "orderedBy" },
        { text: "Picked Up by", value: "pickedUpBy" },
        { text: "Model", value: "model" },

        { text: "Jobsite", value: "jobSite" },

        { text: "Last GPS Address", value: "lastAddress", width: "200px" },
      ],
      accessHeaders: [
        { text: "Access Code Name", value: "description" },
        { text: "Access Code", value: "code" },
        { text: "Actions", value: "action" },
      ],
      excelListOnRent: [],
      excelHeaderOnRent: [],
      startrowOnRent: "",
      pageNumber: 1,
      tempacccode: null,
      pageSize: 100,
      totalRecords: 0,
      totalRecordsCount: 0,
      countLables: [
        {
          name: "25",
          count: 25,
        },
        {
          name: "50",
          count: 50,
        },
        {
          name: "100",
          count: 100,
        },
        {
          name: "ALL",
          count: -1,
        },
      ],
      isExcelLoading: false,
      accessControlCodeDialog: false,
      unAssignConfirmationDivOpen: false,
      defaultAccessControlCode: "",
      defaultAccessControlCodeUnitId: "",
      isUnAssignedBtnSubmit: false,
      assignNewCodeDivOpen: false,
      accessKeysList: [],
      isGetAccessKeys: false,
      newAssignedCode: "",
      isAssignNewCodeBtnSubmit: false,
      createAssignNewCodeDivOpen: false,
      controlCodeFormValid: true,
      rules: rules,
      controlCodeName: "",
      keyValidList: [
        { name: "30Sec", value: "30Sec" },
        { name: "60Sec", value: "60Sec" },
        { name: "90Sec", value: "90Sec" },
      ],
      selectedKeyValid: "",
      keyExpireList: [
        { name: "0sec", value: "0sec" },
        { name: "15sec", value: "15sec" },
        { name: "30sec", value: "30sec" },
        { name: "60sec", value: "60sec" },
        { name: "2min", value: "2min" },
        { name: "5min", value: "5min" },
        { name: "10min", value: "10min" },
        { name: "15min", value: "15min" },
        { name: "30min", value: "30min" },
        { name: "1hour", value: "1hour" },
        { name: "2hours", value: "2hours" },
        { name: "4hours", value: "4hours" },
        { name: "8hours", value: "8hours" },
        { name: "16hours", value: "16hours" },
      ],
      selectedKeyExpire: "",
      controlCodeNotes: "",
      isCreateAndAssignBtnSubmit: false,
      selectedAccessCodeOwnerType: "1",
      accesscontrolDialogAsset: false,
      enableDisableAccess: false,
      name: "",
      controlCodeSerialNumber: "",
      accessKeysLoading: false,
      displayAccessForm: false,
      selectedAccessAssetCustId: "",
      selectedAccessAssetCustName: "",
      isEditAccess: false,
      iscustomerDataLoading: false,
      selectedAssetId: "",
    };
  },
  watch: {
    searchCustomer(val) {
      //check entered text is not undefined and enter search text is multiples of 2 characters
      if (val != undefined && val != "All" && val.length % 2 == 0) {
        this.searchCustomers(val);
      }
    },
  },
  computed: {
    ...mapGetters(["roles", "companyNameDropdown"]),
    startPageCount() {
      return this.pageNumber == -1
        ? 1
        : (this.pageNumber - 1) * this.pageSize + 1;
    },
    endPageCount() {
      return this.pageNumber == -1 || this.pageNumber == 1
        ? this.equipmentsList.length
        : (this.pageNumber - 1) * this.pageSize + this.equipmentsList.length;
    },
  },
  mounted() {
    // getting input content
    this.input = utils.getInputContent("rentalEquipment", this.roles);
    if (this.$route.query && this.$route.query.status) {
      this.status = Number(this.$route.query.status);
    }
    this.readEquipmentsList();
    this.input["rental"] = true;
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        let date = value.split("T")[0];
        return moment(date).format(format);
      }
    },
  },
  methods: {
    async searchCustomers(value) {
      try {
        this.isLoaderCustomer = true;
        const response = await telematicsService.searchBasicCustomers(value);
        if (response.isSuccess) {
          let finaldata = response.data.filter((e) => e.name !== "");
          this.customerList = finaldata.map((item) => {
            return {
              name: item.name ? item.name : "",
              id: String(item.id) ? String(item.id) : "",
            };
          });
          this.isLoaderCustomer = false;
        } else {
          this.isLoaderCustomer = false;
        }
      } catch (err) {
        this.isLoaderCustomer = false;
        console.log(err);
      }
    },
    accessCodeClose(item) {
      this.tempacccode = item;
      this.openUnAssignConfirmation();
    },
    onStatusChange() {
      this.$router.replace({ query: null });
    },
    async readEquipmentsList() {
      this.equipmentsList = [];
      this.isEquipmentsLoading = true;
      let searchQuery = encodeURIComponent(this.searchHeader);
      try {
        let response = await telematicsService.getEquipmentsList(
          this.fromDate,
          this.toDate,
          searchQuery,
          this.status,
          this.pageNumber,
          this.pageSize
        );
        if (response) {
          this.isEquipmentsLoading = false;
          this.equipmentsList = response.data;
          this.totalRecordsCount = response.totalRecords;
          let totalRecords = Math.ceil(this.totalRecordsCount / this.pageSize);
          if (this.pageSize == -1) {
            this.totalRecords = 1;
          } else {
            this.totalRecords = parseInt(totalRecords);
          }
        } else {
          this.isEquipmentsLoading = false;
          this.equipmentsList = [];
        }
      } catch (err) {
        console.log(err);
        this.isEquipmentsLoading = false;
      }
    },
    direction(item) {
      this.$router.push("/?searchkey=" + encodeURIComponent(item.stockKey));
    },
    pageChange() {
      this.readEquipmentsList();
    },
    clearFilters() {
      this.fromDate = "";
      this.toDate = "";
      this.searchHeader = "";
      this.status = 1;
      if (this.$route.query && this.$route.query.status) {
        this.$router.replace({ query: null });
      }
      this.readEquipmentsList();
    },

    async exportTableDataOnRent() {
      this.excelHeaderOnRent = [];
      this.isExcelLoading = true;
      let pageNumber = 1;
      let pageSize = -1;
      let searchQuery = encodeURIComponent(this.searchHeader);
      try {
        let response = await telematicsService.getEquipmentsList(
          this.fromDate,
          this.toDate,
          searchQuery,
          this.status,
          pageNumber,
          pageSize
        );
        if (response) {
          const formatDate = "MM/DD/YYYY";
          this.isExcelLoading = false;
          let excelList = response.data;
          this.excelListOnRent = excelList.map((item) => {
            return {
              stockKey: item.stockKey ? item.stockKey : "",
              name: item.name ? item.name : "",
              contractId: item.contractId
                ? item.contractId + "-" + item.depotId
                : "",
              accessControlCods:
                item.accessCods && item.accessCods.length != 0
                  ? item.accessCods.map((e) => e.accessControlCode).join()
                  : "",
              customerName: item.customerName ? item.customerName : "",
              serialNumber:
                item.tuSerialNumber == null
                  ? item.serialNumber
                  : item.tuSerialNumber,
              quantity: item.quantity == null ? item.quantity : item.quantity,

              deviceModel: item.deviceModel ? item.deviceModel : "",
              initialContractDate: item.initialContractDate
                ? moment(item.initialContractDate.split("T")[0]).format(
                    formatDate
                  )
                : "",
              contractEndDate: item.contractEndDate
                ? moment(item.contractEndDate.split("T")[0]).format(formatDate)
                : "",
              customerPurchaseOrder: item.customerPurchaseOrder
                ? item.customerPurchaseOrder
                : "",
              customerJobNumber: item.customerJobNumber
                ? item.customerJobNumber
                : "",
              model: item.model ? item.model : "",
              orderedBy: item.orderedBy ? item.orderedBy : "",
              pickedUpBy: item.pickedUpBy ? item.pickedUpBy : "",
              itemStatus: item.itemStatus ? item.itemStatus : "",
              jobSite: item.jobSite ? item.jobSite : "",

              excelAddress:
                item.lastAddress == null
                  ? "-"
                  : (item.lastAddress.city
                      ? item.lastAddress.line1 + ", "
                      : item.lastAddress.line1) +
                    (item.lastAddress.postalCode
                      ? item.lastAddress.city + ", "
                      : item.lastAddress.city) +
                    item.lastAddress.postalCode,
            };
          });
          this.startrowOnRent = 3;
          this.excelHeaderOnRent.push(["On Rent Data"]);
          this.startrowOnRent += 1;
          let cust;
          if (this.companyNameDropdown == "") {
            cust = "All";
          } else {
            cust = this.$store.getters.companyNameDropdown;
          }
          this.excelHeaderOnRent.push(["Customer:" + " " + cust]);
          if (this.fromDate) {
            this.startrowOnRent += 1;
            this.excelHeaderOnRent.push(["From Date:" + " " + this.fromDate]);
          }
          if (this.toDate) {
            this.startrowOnRent += 1;
            this.excelHeaderOnRent.push(["To Date:" + " " + this.toDate]);
          }
          if (this.searchHeader) {
            this.startrowOnRent += 1;
            this.excelHeaderOnRent.push([
              "Contact #/Equipment #/Type/PO #/Jobsite :" +
                " " +
                this.searchHeader,
            ]);
          }
          if (this.status) {
            this.startrowOnRent += 1;
            let statustext = "";
            statusExportLabels.forEach(([statusId, label]) => {
              if (this.status == statusId) {
                statustext = label;
              }
            });
            this.excelHeaderOnRent.push(["Status:" + " " + statustext]);
          }
          this.excelHeaderOnRent.push([]);
          this.startrowOnRent += 1;

          this.excelHeaderOnRent.push([
            "Equipment #",
            "Equipment",
            "Telematics SN",
            "Customer Name",
            "Contract#",
            "Item Status",
            "Quantity",
            "Device Model",
            "Start Date",
            "Estimated Return Date",
            "PO#",
            "Job#",
            "Ordered By",
            "Picked Up by",
            "Model",
            "Jobsite",
            "Last GPS Address",
          ]);
          let tempExcel = this.excelListOnRent.map(function (item) {
            // hide accesscontrolcode
            delete item.accessControlCods;
            return item;
          });
          let datarow = "A" + this.startrowOnRent;
          var ws = XLSX.utils.aoa_to_sheet(this.excelHeaderOnRent);
          XLSX.utils.sheet_add_json(ws, tempExcel, {
            header: [
              "stockKey",
              "name",
              "serialNumber",
              "customerName",
              "contractId",
              "itemStatus",
              "quantity",
              "deviceModel",
              "initialContractDate",
              "contractEndDate",
              "customerPurchaseOrder",
              "customerJobNumber",
              "orderedBy",
              "pickedUpBy",
              "model",
              "jobSite",
              "excelAddress",
            ],
            skipHeader: true,
            origin: datarow,
          });
          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "On Rent Data");
          this.excelHeaderOnRent = [];
          XLSX.writeFile(wb, "On Rent Data.xlsx");
        } else {
          this.isExcelLoading = false;
          this.excelListOnRent = [];
          this.$toast.error(response.systemMessage);
        }
      } catch (err) {
        console.log(err);
        this.isExcelLoading = false;
        this.$toast.error("Unable to load the Data" + err);
      }
    },
    getFirstPageData() {
      this.pageNumber = 1;
      this.pageSize = 100;
      this.readEquipmentsList();
    },
    getLastPageData() {
      this.pageNumber = this.totalRecords;
      this.pageSize = 100;
      this.readEquipmentsList();
    },
    // Update Access Control Code Functionalities
    openAccessControlDialog(item) {
      this.defaultAccessControlCode = "";
      this.defaultAccessControlCodeUnitId = "";
      this.accessControlCodeDialog = true;
      this.defaultAccessControlCode = item.accessCods;
      this.defaultAccessControlCodeUnitId = item.tuUnitId;
    },
    cancelAccessControlDialog() {
      this.accessControlCodeDialog = false;
      this.unAssignConfirmationDivOpen = false;
      this.assignNewCodeDivOpen = false;
      this.createAssignNewCodeDivOpen = false;
      this.defaultAccessControlCode = "";
      this.defaultAccessControlCodeUnitId = "";
      this.clearControlCodeFields();
    },

    cancelAccessControlDialogAsset() {
      this.controlCodeSerialNumber = "";
      this.name = "";
      this.enableDisableAccess = false;
      this.isEditAccess = false;
      this.displayAccessForm = false;
    },
    closeAccessControlDialogAsset() {
      this.cancelAccessControlDialogAsset();
      this.accesscontrolDialogAsset = false;
    },
    // *---- First Btn UnAssign Code ------*
    clearControlCodeFields() {
      this.newAssignedCode = "";
      this.controlCodeName = "";
      this.companyName = "";
      this.selectedCustomer = null;
      this.controlCodeSerialNumber = "";
      this.selectedKeyExpire = "";
      this.selectedKeyValid = "";
      this.controlCodeNotes = "";
    },
    openUnAssignConfirmation() {
      this.unAssignConfirmationDivOpen = true;
      this.assignNewCodeDivOpen = false;
      this.createAssignNewCodeDivOpen = false;
      this.clearControlCodeFields();
    },
    cancelUnAssignConfirmation() {
      this.unAssignConfirmationDivOpen = false;
      this.assignNewCodeDivOpen = false;
      this.createAssignNewCodeDivOpen = false;
      this.tempacccode = null;
      this.clearControlCodeFields();
    },
    async unAssignControlCode() {
      this.isUnAssignedBtnSubmit = true;
      let customerId = "";
      let payload = {
        id: this.tempacccode.accessControlKeyId,
        unitId: this.defaultAccessControlCodeUnitId,
        customerId: customerId,
        ownerType: this.selectedAccessCodeOwnerType,
        isGlobal: false,
      };
      try {
        let response = await telematicsService.unAssignAccessControlCode(
          payload
        );
        if (response.isSuccess) {
          this.$toast.success(
            "Access control code is unassigned successfully."
          );
          this.isUnAssignedBtnSubmit = false;
          this.cancelUnAssignConfirmation();
          this.cancelAccessControlDialog();
          this.readEquipmentsList();
        } else {
          this.$toast.error(response.systemMessage);
          this.isUnAssignedBtnSubmit = false;
        }
      } catch (err) {
        console.log(err);
        this.$toast.error("Unable to unassign the access control code" + err);
        this.isUnAssignedBtnSubmit = false;
      }
    },
    // Assign New Code
    assignNewCodeDiv() {
      this.assignNewCodeDivOpen = true;
      this.getAccessKeysList();
      this.createAssignNewCodeDivOpen = false;
      this.unAssignConfirmationDivOpen = false;
      this.clearControlCodeFields();
    },
    cancelAssignNewCode() {
      this.assignNewCodeDivOpen = false;
      this.unAssignConfirmationDivOpen = false;
      this.createAssignNewCodeDivOpen = false;
      this.clearControlCodeFields();
    },
    async getAccessKeysList() {
      this.isGetAccessKeys = true;
      this.accessKeysList = [];
      let customerId = "";
      try {
        let response = await telematicsService.getAccessKeysList(
          customerId,
          this.selectedAccessCodeOwnerType
        );
        if (response && response.data) {
          this.isGetAccessKeys = false;
          let tempArrList = [];
          tempArrList = response.data.map(function (item) {
            return {
              employeeNumber: item.employeeNumber ? item.employeeNumber : "",
              expirationDate: item.expirationDate ? item.expirationDate : "",
              id: item.id ? item.id : "",
              isAdmin: item.isAdmin ? item.isAdmin : "",
              keyExpire: item.keyExpire ? item.keyExpire : "",
              keyValid: item.keyValid ? item.keyValid : "",
              name: item.name ? item.name : "",
              note: item.note ? item.note : "",
              serialNumber: item.serialNumber ? item.serialNumber : "",
              showCodeName:
                (item.serialNumber ? item.serialNumber + " - " : "") +
                (item.name ? item.name : ""),
            };
          });
          this.accessKeysList = tempArrList;
        } else {
          this.isGetAccessKeys = false;
          this.$toast.error("No access codes available");
          this.accessKeysList = [];
        }
      } catch (err) {
        this.isGetAccessKeys = false;
        console.log(err);
      }
    },
    async updateAndAssignNewCode() {
      this.isAssignNewCodeBtnSubmit = true;
      let customerId = "";
      let payload = {
        id: this.newAssignedCode,
        unitId: this.defaultAccessControlCodeUnitId,
        customerId: customerId,
        ownerType: this.selectedAccessCodeOwnerType,
        isGlobal: false,
      };
      try {
        let response = await telematicsService.updateAndAssignNewCode(payload);
        if (response.isSuccess) {
          this.$toast.success(
            "New access control code is assigned successfully."
          );
          this.isAssignNewCodeBtnSubmit = false;
          this.cancelAssignNewCode();
          this.cancelAccessControlDialog();
          this.readEquipmentsList();
        } else {
          this.$toast.error(response.systemMessage);
          this.isAssignNewCodeBtnSubmit = false;
        }
      } catch (err) {
        console.log(err);
        this.$toast.error("Unable to assign the new access control code" + err);
        this.isAssignNewCodeBtnSubmit = false;
      }
    },
    createAndAssignNewCodeDiv() {
      this.createAssignNewCodeDivOpen = true;
      this.assignNewCodeDivOpen = false;
      this.unAssignConfirmationDivOpen = false;
      this.clearControlCodeFields();
    },
    cancelCreateAndAssignNewCodeDiv() {
      this.createAssignNewCodeDivOpen = false;
      this.assignNewCodeDivOpen = false;
      this.unAssignConfirmationDivOpen = false;
      this.clearControlCodeFields();
    },
    async createAndAssignNewCode() {
      this.isCreateAndAssignBtnSubmit = true;
      let unitIdList = [];
      if (this.defaultAccessControlCodeUnitId) {
        unitIdList.push(this.defaultAccessControlCodeUnitId);
      } else {
        unitIdList = [];
      }
      let payload = {
        name: this.controlCodeName,
        companyName: this.companyName,
        serialNumber: this.controlCodeSerialNumber,
        keyValid: this.selectedKeyValid,
        keyExpire: this.selectedKeyExpire,
        note: this.controlCodeNotes,
        units: unitIdList,
        ownerType: this.selectedAccessCodeOwnerType,
        isGlobal: false,
        customerName:
          this.selectedCustomer != null ? this.selectedCustomer["name"] : "",
        customerId:
          this.selectedCustomer != null ? this.selectedCustomer["id"] : "",
      };
      try {
        let response = await telematicsService.createAndAssignNewCode(payload);
        if (response.isSuccess) {
          this.$toast.success(
            "Access control code is created & assigned successfully."
          );
          this.isCreateAndAssignBtnSubmit = false;
          this.cancelCreateAndAssignNewCodeDiv();
          this.cancelAccessControlDialog();
          this.readEquipmentsList();
        } else {
          this.$toast.error(
            "Failed to create and assign access code. please try again after sometime."
          );
          this.isCreateAndAssignBtnSubmit = false;
        }
      } catch (err) {
        console.log(err);
        this.$toast.error(
          "Unable to create & assign the access control code" + err
        );
        this.isCreateAndAssignBtnSubmit = false;
      }
    },
    async viewAccessCodeAssets(customerId, customerName, assetId) {
      this.accesscontrolDialogAsset = true;
      this.selectedAccessAssetCustId = customerId;
      this.selectedAccessAssetCustName = customerName;
      this.selectedAssetId = assetId;

      try {
        this.iscustomerDataLoading = true;
        const response = await telematicsService.getAccessCodesByAssets(
          customerId,
          assetId
        );
        if (response.isSuccess) {
          this.accessCodesList = response.data;
          this.iscustomerDataLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.iscustomerDataLoading = false;
      }
    },
    async saveAccessKeys() {
      this.accessKeysLoading = true;
      try {
        let payload = {
          code:
            this.enableDisableAccess == true
              ? this.controlCodeSerialNumber
              : "",
          description: this.enableDisableAccess == true ? this.name : "",
          isEnabled: this.enableDisableAccess,
          masterKeyType: "PRIVATE_KEY",
          assetIds: this.selectedAssetId,
          customerId: this.selectedAccessAssetCustId,
          customerName: this.selectedAccessAssetCustName,
        };
        let response = await telematicsService.saveAccessKeys(payload);
        if (response) {
          this.$toast.success(response.systemMessage);
          this.viewAccessCodeAssets(
            this.selectedAccessAssetCustId,
            this.selectedAccessAssetCustName,
            this.selectedAssetId
          );
          this.accessKeysLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.accessKeysLoading = false;
      }
    },
    async updateAccessKeys() {
      this.accessKeysLoading = true;
      try {
        let payload = {
          code:
            this.enableDisableAccess == true
              ? this.controlCodeSerialNumber
              : "",
          description: this.enableDisableAccess == true ? this.name : "",
          assetIds: this.selectedAssetId,

          masterKeyType: "PRIVATE_KEY",
          isEnabled: this.enableDisableAccess,

          customerId: this.selectedAccessAssetCustId,
          customerName: this.selectedAccessAssetCustName,
        };

        let response = await telematicsService.updateAccessKeys(
          this.itemid,
          payload
        );
        if (response) {
          this.$toast.success(response.systemMessage);
          this.accessKeysLoading = false;
          this.viewAccessCodeAssets(
            this.selectedAccessAssetCustId,
            this.selectedAccessAssetCustName,
            this.selectedAssetId
          );
        }
      } catch (err) {
        console.log(err);
        this.accessKeysLoading = false;
      }
    },
    showAccessData() {
      this.displayAccessForm = true;
    },
    EditAccessDialog(item) {
      this.isEditAccess = true;
      this.displayAccessForm = true;
      this.controlCodeSerialNumber = item.code;
      this.enableDisableAccess =
        item.code != "" && item.code != null ? true : false;
      this.name = item.description;
      this.itemid = item.id;
    },
  },
};
